import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed, Subscribable, SubscribableOrNullableValue } from 'knockout';
import { Tag } from 'models/tag';
import { TopicThread } from 'models/topicThread';
import './tags.html';
import './tags.scss';

components.preload('tags-list');

export interface CommentTagsVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
}

@injectable()
export default class CommentTagsVM {
    tags: Subscribable<Array<Tag>>
    hasTags: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentTagsVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const comment = ko.flattenComputed(config.comment);

        this.tags = comment.pluck(c => c.tags, []);
        this.hasTags = this.tags.any();

        ko.applyBindingsToNode(info.element, {
            'visible': this.hasTags,

            'css': {
                'topic__comment__tags': true
            }
        });
    }
}